/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Content_Honor_0_Item_3_TitleInputs */

const en_about_content_honor_0_item_3_title = /** @type {(inputs: About_Content_Honor_0_Item_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2021 Iowa Golf Association PGA Professional of the Year`)
};

const es_about_content_honor_0_item_3_title = /** @type {(inputs: About_Content_Honor_0_Item_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profesional PGA del Año 2021 de la Iowa Golf Association`)
};

const de_about_content_honor_0_item_3_title = /** @type {(inputs: About_Content_Honor_0_Item_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA-Professional des Jahres 2021 der Iowa Golf Association`)
};

const zh_about_content_honor_0_item_3_title = /** @type {(inputs: About_Content_Honor_0_Item_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2021 年 Iowa Golf Association 年度 PGA 职业人士`)
};

const ar_about_content_honor_0_item_3_title = /** @type {(inputs: About_Content_Honor_0_Item_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`محترف PGA لعام 2021 من Iowa Golf Association`)
};

const fr_about_content_honor_0_item_3_title = /** @type {(inputs: About_Content_Honor_0_Item_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Professionnel PGA de l’année 2021 de la Iowa Golf Association`)
};

const vi_about_content_honor_0_item_3_title = /** @type {(inputs: About_Content_Honor_0_Item_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chuyên gia PGA của năm 2021 của Iowa Golf Association`)
};

const sw_about_content_honor_0_item_3_title = /** @type {(inputs: About_Content_Honor_0_Item_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mtaalamu wa PGA wa Mwaka 2021 wa Iowa Golf Association`)
};

const th_about_content_honor_0_item_3_title = /** @type {(inputs: About_Content_Honor_0_Item_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`มืออาชีพ PGA แห่งปี 2021 ของ Iowa Golf Association`)
};

const bs_about_content_honor_0_item_3_title = /** @type {(inputs: About_Content_Honor_0_Item_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA profesionalac godine 2021 prema Iowa Golf Association`)
};

const ja_about_content_honor_0_item_3_title = /** @type {(inputs: About_Content_Honor_0_Item_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2021年 Iowa Golf Association 年間最優秀PGAプロフェッショナル`)
};

const ko_about_content_honor_0_item_3_title = /** @type {(inputs: About_Content_Honor_0_Item_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2021 Iowa Golf Association 올해의 PGA 프로`)
};

const pt_about_content_honor_0_item_3_title = /** @type {(inputs: About_Content_Honor_0_Item_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profissional PGA do Ano da Iowa Golf Association 2021`)
};

const it_about_content_honor_0_item_3_title = /** @type {(inputs: About_Content_Honor_0_Item_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Professionista PGA dell’anno 2021 della Iowa Golf Association`)
};

const sv_about_content_honor_0_item_3_title = /** @type {(inputs: About_Content_Honor_0_Item_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa Golf Associations Årets PGA-professional 2021`)
};

const nl_about_content_honor_0_item_3_title = /** @type {(inputs: About_Content_Honor_0_Item_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA Professional van het Jaar 2021 van de Iowa Golf Association`)
};

const da_about_content_honor_0_item_3_title = /** @type {(inputs: About_Content_Honor_0_Item_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa Golf Association's Årets PGA-professionelle 2021`)
};

const nb_about_content_honor_0_item_3_title = /** @type {(inputs: About_Content_Honor_0_Item_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa Golf Associations Årets PGA-profesjonelle 2021`)
};

const fi_about_content_honor_0_item_3_title = /** @type {(inputs: About_Content_Honor_0_Item_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa Golf Associationin vuoden PGA-ammattilainen 2021`)
};

const pl_about_content_honor_0_item_3_title = /** @type {(inputs: About_Content_Honor_0_Item_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profesjonalista PGA Roku 2021 według Iowa Golf Association`)
};

const ru_about_content_honor_0_item_3_title = /** @type {(inputs: About_Content_Honor_0_Item_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Профессионал PGA года 2021 по версии Iowa Golf Association`)
};

const tr_about_content_honor_0_item_3_title = /** @type {(inputs: About_Content_Honor_0_Item_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa Golf Association 2021 Yılın PGA Profesyoneli`)
};

const hi_about_content_honor_0_item_3_title = /** @type {(inputs: About_Content_Honor_0_Item_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa Golf Association का 2021 का वर्ष का सर्वश्रेष्ठ PGA प्रोफ़ेशनल`)
};

const id_about_content_honor_0_item_3_title = /** @type {(inputs: About_Content_Honor_0_Item_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profesional PGA Terbaik 2021 dari Iowa Golf Association`)
};

const ms_about_content_honor_0_item_3_title = /** @type {(inputs: About_Content_Honor_0_Item_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profesional PGA Terbaik 2021 Iowa Golf Association`)
};

const cs_about_content_honor_0_item_3_title = /** @type {(inputs: About_Content_Honor_0_Item_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PGA profesionál roku 2021 podle Iowa Golf Association`)
};

const el_about_content_honor_0_item_3_title = /** @type {(inputs: About_Content_Honor_0_Item_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Επαγγελματίας PGA της Χρονιάς 2021 της Iowa Golf Association`)
};

const he_about_content_honor_0_item_3_title = /** @type {(inputs: About_Content_Honor_0_Item_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מקצוען ה-PGA של השנה 2021 מטעם Iowa Golf Association`)
};

const af_about_content_honor_0_item_3_title = /** @type {(inputs: About_Content_Honor_0_Item_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2021 Iowa Golf Association PGA-professional van die Jaar`)
};

const hu_about_content_honor_0_item_3_title = /** @type {(inputs: About_Content_Honor_0_Item_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Az Iowa Golf Association 2021-es év PGA-profija`)
};

/**
* | output |
* | --- |
* | "2021 Iowa Golf Association PGA Professional of the Year" |
*
* @param {About_Content_Honor_0_Item_3_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const about_content_honor_0_item_3_title = /** @type {((inputs?: About_Content_Honor_0_Item_3_TitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Content_Honor_0_Item_3_TitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_about_content_honor_0_item_3_title(inputs)
	if (locale === "de") return de_about_content_honor_0_item_3_title(inputs)
	if (locale === "zh") return zh_about_content_honor_0_item_3_title(inputs)
	if (locale === "ar") return ar_about_content_honor_0_item_3_title(inputs)
	if (locale === "fr") return fr_about_content_honor_0_item_3_title(inputs)
	if (locale === "vi") return vi_about_content_honor_0_item_3_title(inputs)
	if (locale === "sw") return sw_about_content_honor_0_item_3_title(inputs)
	if (locale === "th") return th_about_content_honor_0_item_3_title(inputs)
	if (locale === "bs") return bs_about_content_honor_0_item_3_title(inputs)
	if (locale === "ja") return ja_about_content_honor_0_item_3_title(inputs)
	if (locale === "ko") return ko_about_content_honor_0_item_3_title(inputs)
	if (locale === "pt") return pt_about_content_honor_0_item_3_title(inputs)
	if (locale === "it") return it_about_content_honor_0_item_3_title(inputs)
	if (locale === "sv") return sv_about_content_honor_0_item_3_title(inputs)
	if (locale === "nl") return nl_about_content_honor_0_item_3_title(inputs)
	if (locale === "da") return da_about_content_honor_0_item_3_title(inputs)
	if (locale === "nb") return nb_about_content_honor_0_item_3_title(inputs)
	if (locale === "fi") return fi_about_content_honor_0_item_3_title(inputs)
	if (locale === "pl") return pl_about_content_honor_0_item_3_title(inputs)
	if (locale === "ru") return ru_about_content_honor_0_item_3_title(inputs)
	if (locale === "tr") return tr_about_content_honor_0_item_3_title(inputs)
	if (locale === "hi") return hi_about_content_honor_0_item_3_title(inputs)
	if (locale === "id") return id_about_content_honor_0_item_3_title(inputs)
	if (locale === "ms") return ms_about_content_honor_0_item_3_title(inputs)
	if (locale === "cs") return cs_about_content_honor_0_item_3_title(inputs)
	if (locale === "el") return el_about_content_honor_0_item_3_title(inputs)
	if (locale === "he") return he_about_content_honor_0_item_3_title(inputs)
	if (locale === "af") return af_about_content_honor_0_item_3_title(inputs)
	if (locale === "hu") return hu_about_content_honor_0_item_3_title(inputs)
	return en_about_content_honor_0_item_3_title(inputs)
});